module.exports = __webpack_public_path__ + "img/noRead.b864c87c.png";